import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-clear-driver-flags-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './clear-driver-flags-dialog.html',
  styleUrl: './clear-driver-flags-dialog.css'
})
export class ClearDriverFlagsDialog implements OnInit {
  @Input() username: string = '';
  @Input() truckId: string = '';
  @Input() submitting: boolean = false;

  @Output() closed = new EventEmitter<void>();
  @Output() submit = new EventEmitter<{ clearWelcome: boolean; clearDisclosure: boolean; truckId: string }>();

  clearWelcome: boolean = false;
  clearDisclosure: boolean = false;
  draftTruckId: string = '';

  ngOnInit(): void {
    this.draftTruckId = this.truckId;
  }

  onCancel(): void {
    this.closed.emit();
  }

  onSubmit(): void {
    this.submit.emit({
      clearWelcome: this.clearWelcome,
      clearDisclosure: this.clearDisclosure,
      truckId: this.draftTruckId
    });
  }
}


